<script>
	import { fly } from "svelte/transition";
	import { formatFloat } from "./utils.js";
	import { parties, options } from "./constants.js";

	export let tooltip;
	export let animateFly = false;
	export let region;
	export let isSelected;
	// export let maxPartyBars;
	export let isTotal;
	export let closeCbk = (d) => {};

	const frmt = formatFloat({ postfix: "%", decimal: true, multiplier: 100 });

	$: parties.sort((a, b) => {
		if (a.id === "sonstige") return 1; // keep 'sonstige' at the end
		if (b.id === "sonstige") return -1; // keep 'sonstige' at the end
		return region[b.id] - region[a.id]; // sort by result in descending order
	});
</script>

<div
	class="tooltip"
	on:click
	on:mouseover
	on:focus={() => {}}
	on:blur={() => {}}
	on:mouseout
	transition:fly={{ y: 100, duration: animateFly ? 400 : 0 }}
	bind:this={tooltip}
>
	<div class="tooltip-top">
		<div class="header">
			<div class="region">{region.regionLabel}</div>
			<div class="title-bezirk">
				<span class="title">{@html region.nameLong.replace("/", "/&#8203;")}</span>
				{#if !isTotal}
					<span class="bezirk">in {region.bezirk}</span>
				{/if}
			</div>
			{#if !isTotal}
				<div class="note">
					{#if region.isPlural}
						Mit gemeinsamer Briefwahl
					{:else}
						Mit Briefwahlstimmen
					{/if}
				</div>
			{/if}
		</div>
		{#if isSelected}
			<div class="button-back" on:click={closeCbk} />
		{/if}
	</div>
	<div class="rule" />
	<div class="results-separate">
		{#each options as o}
			<div class="result-option {o.value}" style:color={o.color}>
				<div class="text">
					<div class="label">
						{o.label}
					</div>
					<div class="value">
						{frmt(region[o.value])}
					</div>
				</div>
				<div class="bar-container">
					<div class="bar" style:background-color={o.color} style:width="{region[o.value] * 100}%" />
				</div>
			</div>
		{/each}
	</div>
	<div class="rule" />
	<div class="results-combined">
		<div class="wahlbeteiligung">
			Wahlbeteiligung <span>{frmt(region.wahlbeteiligung)}</span>
		</div>
		<div class="bar-container">
			<div class="bar">
				{#each options as o}
					<div
						class="bar-item {o.value}"
						style:background-color={o.colorLight}
						style:width="{region[o.value] * region.wahlbeteiligung * 100}%"
					/>
				{/each}
			</div>
			<div class="marker-25" style:left="{25}%">
				<div class="text">
					{frmt(0.25)}
				</div>
			</div>
		</div>
	</div>
	<!-- <div class="rule" />
	<div class="results-agh">
		<div class="agh-title">Ergebnis Abgeordnetenhauswahl 2023</div>
		<div class="agh-bar-chart">
			{#each parties as p}
				<div class="party {p.id}" style:color={p.color}>
					<div class="text">
						<div class="label">
							{p.name}
						</div>
						<div class="value">
							{frmt(region[p.id])}
						</div>
					</div>
					<div class="bar-container">
						<div class="bar" style:background-color={p.color} style:width="{(100 * region[p.id]) / maxPartyBars}%" />
					</div>
				</div>
			{/each}
		</div>
	</div> -->
</div>

<style lang="scss">
	$tooltip-offset: 25vh;
	$padding-top: 17px;
	$padding-right: 10px;
	$padding-bottom: 25px;
	$padding-left: 15px;

	.tooltip {
		background: white;
		padding: $padding-top $padding-right $padding-bottom $padding-left;
		position: absolute;
		top: 100px;
		right: 10px;
		font-size: 16px;
		line-height: 120%;
		border-radius: 3px;
		box-shadow: 0 4px 5px rgba(0, 0, 0, 0.15);
		width: 286px;
		box-sizing: border-box;
		z-index: 1;
		overflow: hidden;
	}

	@media (max-width: $breakpoint-mobile-l) {
		$padding-top: 10px;
		$padding-right: 15px;
		$padding-bottom: 10px;
		$padding-left: 15px;

		.tooltip {
			padding: $padding-top $padding-right $padding-bottom $padding-left;
			position: absolute;
			top: calc(100% - #{$tooltip-offset});
			width: 100%;
			left: 0;
			right: 0;
			border-radius: 10px;
			box-shadow: 0 3px 10px rgba(0, 0, 0, 0.3);
		}

		.results-agh::before {
			width: calc(100% + #{$padding-left} + #{$padding-right}) !important;
			height: calc(100% + #{$padding-bottom});
			left: calc(-#{$padding-left}) !important;
		}
	}

	.results-separate {
		font-weight: 600;
	}

	.result-option,
	.party {
		display: flex;
		gap: 5px;
		align-items: center;
		margin-bottom: 3px;

		.text {
			width: 50%;
			display: flex;
			justify-content: space-between;
		}

		.value {
			text-align: right;
		}

		.bar-container {
			height: 100%;
			width: 50%;

			.bar {
				height: 7px;
				border-radius: 0px 2px 2px 0px;
			}
		}
	}

	.results-agh {
		position: relative;

		&::before {
			content: "";
			width: calc(100% + #{$padding-left} + #{$padding-right});
			height: calc(100% + #{$padding-bottom} + 12px);
			left: calc(-#{$padding-left});
			top: -8.5px;
			display: block;
			position: absolute;
			background: #f2f2f2;
			z-index: -1;
		}

		.agh-title {
			margin-bottom: 8px;
			font-size: 16px;
			line-height: 120%;
		}
	}

	.party {
		.label {
			font-weight: 500;
		}
	}

	.results-combined {
		.wahlbeteiligung {
			font-size: 16px;
			line-height: 120%;
			color: #999999;
			margin-bottom: 5px;

			span {
				font-weight: 600;
			}
		}

		.bar-container {
			position: relative;
			height: 45px;

			.bar {
				height: 18px;
				width: 100%;
				border-radius: 3px;
				background: #f2f2f2;
				overflow: hidden;
				display: flex;

				.bar-item {
					height: 100%;
					border-right: 1px solid white;
				}
			}

			.marker-25 {
				color: #0050fe;
				font-weight: 500;
				font-size: 13px;
				position: absolute;
				top: 0px;

				.text {
					transform: translateX(-50%);
				}

				&::before {
					content: "";
					display: block;
					width: 1px;
					height: 28px;
					background: #0050fe;
					box-shadow: 0px 0px 2px #ffffff, 0px 0px 1px #ffffff;
				}
			}
		}
	}

	.rule {
		height: 1px;
		background: #cdcdcd;
		margin: 8px 0;
	}

	.tooltip-top {
		display: flex;
		justify-content: space-between;
	}

	.button-close {
		cursor: pointer;
		background-position: center center;
		background-image: url(../assets/images/icons/icon_close.svg);
		background-repeat: no-repeat;
		width: 20px;
		height: 20px;
		background-size: contain;
		margin-right: 5px;
	}

	.button-back {
		cursor: pointer;
		background-position: center center;
		background-image: url(../assets/images/icons/icon_back.svg);
		background-repeat: no-repeat;
		width: 20px;
		height: 20px;
		background-size: contain;
		margin-right: 5px;
	}

	.header {
		.region {
			color: #8b8b8b;
			font-weight: 400;
			font-size: 11px;
			line-height: 11px;
			letter-spacing: 1px;
			text-transform: uppercase;
			margin-bottom: 3px;
		}

		.title-bezirk {
			font-size: 15px;
			line-height: 120%;
			margin-bottom: 5px;

			.title {
				font-weight: 600;
			}
		}

		.note {
			color: #999999;
			font-size: 14px;
			line-height: 120%;
		}
	}

	@media (max-width: $breakpoint-mobile-l) {
		.title,
		.bezirk {
			display: inline;
		}

		.button-close {
			margin-right: 0px;
		}

		.header {
			position: relative;
			padding-right: 20px;
			margin-bottom: 8px;
		}
	}
</style>
